<template>
  <v-container>
      <v-form v-if="!loading" ref="form" v-model="valid">
          <div v-if="!Active">
              <v-card>
                  <v-card-title>
                      Executive Board Application for Service
                      on the Commission on Uniform Legislation
                      <p>
                          <span style="font-size:smaller; font-weight:bold; margin-left: 50px; display:inline-block; margin-right: 50px">This application is not currently active. Please check back later or contact the Legislative Research Council for more information.</span>
                      </p>
                  </v-card-title>
              </v-card>
          </div>
          <div v-else-if="submitted">
              <v-card>
                  <v-card-title>
                      Executive Board Application for Service
                      on the Commission on Uniform Legislation
                      <p>
                          <br /><span style="font-size:smaller; font-weight:bold; display:inline-block; margin-right: 50px">Thank you for submitting your application. We have received your information and it is currently under review. Please <a href="https://sdlegislature.gov/">click here</a> to return the SDLegislature home page.</span>
                      </p>
                  </v-card-title>
              </v-card>
          </div>
          <div v-else>
              <v-card class="mb-4 pa-4">
                  <v-card-title style="display:flex; flex-direction:column; align-items:flex-start;">
                      <span>
                          Executive Board Application for Service on the Commission on Uniform Legislation
                      </span>
                      <span style="font-size: medium; font-style:italic;">
                          Application Deadline: {{ new Date(endDate).toLocaleDateString('en-US') }}
                      </span>
                  </v-card-title>
                  <v-row dense>
                      <v-col cols="12" md="4">
                          <v-text-field v-model="form.FirstName" maxlength="50" label="First Name" outlined :rules="[v => !!v || 'First Name is Required']" required density="compact" />
                      </v-col>
                      <v-col cols="12" md="4">
                          <v-text-field v-model="form.MiddleName" maxlength="50" label="Middle Name / Initial" outlined density="compact" />
                      </v-col>
                      <v-col cols="12" md="4">
                          <v-text-field v-model="form.LastName" maxlength="50" label="Last Name" outlined :rules="[v => !!v || 'Last Name is Required']" required density="compact" />
                      </v-col>
                  </v-row>

                  <!-- Address -->
                  <v-text-field v-model="form.Street" maxlength="75" label="Street / Box" outlined :rules="[v => !!v || 'Street/Box is Required']" required />

                  <v-row>
                      <v-col cols="12" md="4">
                          <v-text-field v-model="form.City" maxlength="50" label="City" outlined :rules="[v => !!v || 'City is Required']" required />
                      </v-col>
                      <v-col cols="12" md="4">
                          <!--<v-text-field v-model="form.State" label="State" outlined :rules="[v => !!v || 'Required']" required />-->
                          <v-autocomplete v-model="form.State"
                                          :items="States"
                                          item-text="name"
                                          item-value="abbreviation"
                                          autocomplete="address-level1"
                                          :rules="[v => !!v || 'State is Required', v => States.some(state => state.abbreviation === v) || 'Please select a valid state']"
                                          required
                                          clearable
                                          outlined
                                          label="State" />
                      </v-col>
                      <v-col cols="12" md="4">
                          <v-text-field v-model="form.Zip" maxlength="15" label="Zip" outlined :rules="zipRules" required />
                      </v-col>
                  </v-row>
                  <!-- Contact -->
                  <v-row>
                      <v-col cols="12" md="6">
                          <v-text-field v-model="form.Email" maxlength="75" label="Email" outlined :rules="emailRules" required />
                      </v-col>
                      <v-col cols="12" md="2">
                          <v-text-field v-model="form.HomePhone" maxlength="15" label="Home Phone" placeholder="xxx-xxx-xxxx" v-mask="'###-###-####'" outlined :rules="phoneRules" required />
                      </v-col>
                      <v-col cols="12" md="2">
                          <v-text-field v-model="form.OfficePhone" maxlength="15" label="Office Phone" placeholder="xxx-xxx-xxxx" v-mask="'###-###-####'" :rules="secondaryPhoneRules" outlined />
                      </v-col>
                      <v-col cols="12" md="2">
                          <v-text-field v-model="form.CellPhone" maxlength="15" label="Cell Phone" placeholder="xxx-xxx-xxxx" v-mask="'###-###-####'" :rules="secondaryPhoneRules" outlined />
                      </v-col>
                  </v-row>
              </v-card>

              <!-- Education -->
              <v-card class="mb-4 pa-4">
                  <v-card-title>Educational Background</v-card-title>
                  <v-textarea aria-label="Provide your Educational Background" label="Educational Background" v-model="form.EducationalBackground" maxlength="1000" rows="4" outlined :rules="[v => !!v || 'Educational Background is Required']" required />
              </v-card>

              <!-- Occupation -->
              <v-card class="mb-4 pa-4">
                  <v-card-title>Current Occupation</v-card-title>

                  <v-text-field v-model="form.CurrentOccupation" maxlength="150" label="Occupation" aria-label="Provide your current occupation" outlined :rules="[v => !!v || 'Current Occupation is Required']" required />

                  <v-row>
                      <v-col cols="12" md="6">
                          <v-text-field v-model="form.OccupationFrom" maxlength="7" label="From (MM/YYYY)" aria-label="Employed from (MM/YYYY)" outlined :rules="monthYearRule" required />
                      </v-col>
                      <v-col cols="12" md="6">
                          <v-text-field v-model="form.OccupationTo" maxlength="7" label="To (MM/YYYYY)" aria-label="Employed to (MM/YYYY)" outlined :rules="monthYearRule" required />
                      </v-col>
                  </v-row>
              </v-card>

              <!-- Experience -->
              <v-card class="mb-4 pa-4">
                  <v-card-title>Past Occupational Experience</v-card-title>
                  <v-textarea aria-label="List your past occupational experience" label="Past Occupational Experience" v-model="form.PastOccupation" maxlength="1000" rows="4" outlined :rules="[v => !!v || 'Past Occupation is Required']" required />
              </v-card>

              <v-card class="mb-4 pa-4">
                  <v-card-title>Summary of Civic Service</v-card-title>
                  <v-textarea aria-label="Provide a summary of Civic Service" label="Summary of Civic Service" v-model="form.CivicService" maxlength="1000" rows="4" outlined :rules="[v => !!v || 'Civic Service is Required']" required />
              </v-card>

              <v-card class="mb-4 pa-4">
                  <v-card-title>State reason for seeking membership on the Council, including relevant background and experience.</v-card-title>
                  <v-textarea aria-label="State reason for seeking membership on the Council, including relevant background and experience" label="State reason for seeking membership on the Council" v-model="form.Reason" maxlength="1000" rows="4" outlined :rules="[v => !!v || 'Reason for seeking membership is Required']" required />
              </v-card>

              <v-card class="mb-4 pa-4">
                  <v-row>
                      <v-col cols="12" md="12">
                          <v-radio-group v-model="form.PreviouslyServed"
                                         label="Have you previously served on or applied for service on the Commission?"
                                         :rules="[v => v!=null || 'Required']"
                                         required
                                         aria-label="Have you previously served on or applied for service on the Commission?"
                                         row>
                              <v-radio label="Yes" :value="true" />
                              <v-radio label="No" :value="false" />
                          </v-radio-group>
                          <v-text-field v-if="form.PreviouslyServed"
                                        v-model="form.ServedWhen"
                                        maxlength="500"
                                        label="When / Details"
                                        aria-label="When did you previously serve and provide any additional details"
                                        :rules="[v => !!v || 'Previously served details are required']"
                                        outlined />
                      </v-col>
                  </v-row>
              </v-card>

              The Commission on Uniform Legislation is found in SDCL Chapter 2-11. <br /><br />
              SDCL 2-11-1 Composition of commission—Appointment and terms—Life members—Vacancies.<br />
              <span style="font-size:smaller; font-weight:bold; margin-left: 50px; display:inline-block; margin-right: 50px">The appointed members of the Commission on Uniform Legislation consist of five suitable persons learned in the law, appointed by the Executive Board of the Legislative Research Council for terms of three years each. The terms shall begin on the first of August of the year of appointment. The terms shall be staggered so that no more than two terms expire each year. The members shall hold office until their successors have been appointed. Any person, not otherwise a member of the commission, elected as a life member of the National Conference of Commissioners on Uniform State Laws, shall also be a life member of the commission. Vacancies shall be filled by appointment by the Executive Board for the remainder of the term in which the vacancy occurred.</span>
              <v-card class="mb-4 pa-4">
                  <v-row>
                      <v-col cols="12" md="12">
                          <div class="mb-2">
                              Considering the above-cited statute, do you feel that you could legally serve on the Council?
                          </div>

                          <div id="statute-label" class="sr-only">
                              Based on statue SDCL 2 dash 11 dash 1, do you feel that you could legally serve on the Council.  SDCL 2 dash 11 dash 1 provides, in part:
                              The appointed members of the Commission on Uniform Legislation consist
                              of five suitable persons learned in the law, appointed by the Executive Board
                              of the Legislative Research Council for terms of three years each.
                              The terms shall begin on the first of August of the year of appointment.
                              The terms shall be staggered so that no more than two terms expire each year.
                              The members shall hold office until their successors have been appointed.
                              Any person, not otherwise a member of the commission, elected as a life member
                              of the National Conference of Commissioners on Uniform State Laws,
                              shall also be a life member of the commission. Vacancies shall be filled
                              by appointment by the Executive Board for the remainder of the term in which the vacancy occurred.
                          </div>

                          <v-radio-group v-model="form.LegallyServe"
                                         :rules="[v => v!=null || 'Required']"
                                         aria-labelledby="serve-question"
                                         aria-describedby="serve-description"
                                         required
                                         row>
                              <v-radio label="Yes" :value="true" aria-describedby="statute-label" />
                              <v-radio label="No" :value="false" aria-describedby="statute-label" />
                          </v-radio-group>
                      </v-col>
                  </v-row>
              </v-card>


              <v-card class="mb-4 pa-4">
                  <v-card-title>Please list the names, telephone numbers, and emails of three references that the Board may contact.</v-card-title>

                  <v-row v-for="(ref, i) in form.References" :key="i">
                      <v-col cols="12" md="4">
                          <v-text-field v-model="ref.Name" :label="`Reference ${i+1} Name`" maxlength="100" outlined :rules="[v => !!v || 'Reference Name is Required']" required />
                      </v-col>
                      <v-col cols="12" md="4">
                          <v-text-field v-model="ref.Phone" :label="`Reference ${i+1} Phone`" placeholder="xxx-xxx-xxxx" v-mask="'###-###-####'" maxlength="15" outlined :rules="phoneRules" required />
                      </v-col>
                      <v-col cols="12" md="4">
                          <v-text-field v-model="ref.Email" :label="`Reference ${i+1} Email`" maxlength="100" outlined :rules="optionalEmailRules" />
                      </v-col>
                  </v-row>
              </v-card>

              <v-card class="mb-4 pa-4">
                  <v-card-title>Please type your Signature.</v-card-title>
                  <v-row>
                      <v-col cols="12" md="12">
                          <v-text-field v-model="form.Signature" label="Signature" aria-label="Please type your Signature." maxlength="100" outlined :rules="[v => !!v || 'Signature is Required']" required />
                      </v-col>
                  </v-row>
              </v-card>

              Certification and Electronic Signature Acknowledgment
              <v-card class="mb-4 pa-4">
                  <v-col cols="12" md="12">
                      <v-checkbox v-model="Acknowledgment"
                                  :rules="[v => v === true || 'You must acknowledge this before submitting']"
                                  label="By submitting this form and providing my electronic signature, I certify that I am the individual identified in this document and that all information provided is true, accurate, and complete to the best of my knowledge." />
                  </v-col>
              </v-card>

              <span style="font-size: smaller; font-weight:bold">NOTE: You may be asked to be available remotely or in person for a brief interview.</span><br />

              <span style="font-size: smaller; font-style:italic">Individuals needing assistance, pursuant to the Americans with Disabilities Act, should contact the Legislative Research Council at 605-773-3251.</span><br /><br />
              <!-- Submit -->
              <v-btn :disabled="submitting || loading" color="primary" @click="submit" aria-label="Submit the application">Submit</v-btn>
              <v-alert v-if="submitted" type="success">
                  The application has been successfully submitted
              </v-alert>
          </div>
      </v-form>
  </v-container>
</template>

<script>
    import StateComponent from '@/Components/StateComponent.vue';
    export default {
        name: 'CommissionOnUniformLegislation',
        components: {
            StateComponent: StateComponent
        },
      data() {
        return {
            valid: false,
            submitting: false,
            submitted: false,
            Acknowledgment: false,
            loading: true,
            Active: false,
            item: null,
            endDate: null,
            form: {
                FirstName: "",
                MiddleName: "",
                LastName: "",
                Street: "",
                City: "",
                State: "",
                Zip: "",
                Email: "",
                HomePhone: "",
                OfficePhone: "",
                CellPhone: "",
                EducationalBackground: "",
                CurrentOccupation: "",
                OccupationFrom: "",
                OccupationTo: "",
                PastOccupation: "",
                CivicService: "",
                Reason: "",
                PreviouslyServed: null,
                ServedWhen: "",
                Party: "",
                LegallyServe: null,
                References: [
                    { Name: "", Phone: "", Email: "" },
                    { Name: "", Phone: "", Email: "" },
                    { Name: "", Phone: "", Email: "" },
                ],
                Signature: "",
                DateSigned: ""
            },

            resetForm: {
                FirstName: "",
                MiddleName: "",
                LastName: "",
                Street: "",
                City: "",
                State: "",
                Zip: "",
                Email: "",
                HomePhone: "",
                OfficePhone: "",
                CellPhone: "",
                EducationalBackground: "",
                CurrentOccupation: "",
                OccupationFrom: "",
                OccupationTo: "",
                PastOccupation: "",
                CivicService: "",
                Reason: "",
                PreviouslyServed: false,
                ServedWhen: "",
                Party: "",
                LegallyServe: false,
                References: [
                    { Name: "", Phone: "", Email: "" },
                    { Name: "", Phone: "", Email: "" },
                    { Name: "", Phone: "", Email: "" },
                ],
                Signature: "",
                DateSigned: ""
            },
            States: [
                { "name": "Alabama", "abbreviation": "AL" },
                { "name": "Alaska", "abbreviation": "AK" },
                { "name": "American Samoa", "abbreviation": "AS" },
                { "name": "Arizona", "abbreviation": "AZ" },
                { "name": "Arkansas", "abbreviation": "AR" },
                { "name": "California", "abbreviation": "CA" },
                { "name": "Colorado", "abbreviation": "CO" },
                { "name": "Connecticut", "abbreviation": "CT" },
                { "name": "Delaware", "abbreviation": "DE" },
                { "name": "District Of Columbia", "abbreviation": "DC" },
                { "name": "Federated States Of Micronesia", "abbreviation": "FM" },
                { "name": "Florida", "abbreviation": "FL" },
                { "name": "Georgia", "abbreviation": "GA" },
                { "name": "Guam", "abbreviation": "GU" },
                { "name": "Hawaii", "abbreviation": "HI" },
                { "name": "Idaho", "abbreviation": "ID" },
                { "name": "Illinois", "abbreviation": "IL" },
                { "name": "Indiana", "abbreviation": "IN" },
                { "name": "Iowa", "abbreviation": "IA" },
                { "name": "Kansas", "abbreviation": "KS" },
                { "name": "Kentucky", "abbreviation": "KY" },
                { "name": "Louisiana", "abbreviation": "LA" },
                { "name": "Maine", "abbreviation": "ME" },
                { "name": "Marshall Islands", "abbreviation": "MH" },
                { "name": "Maryland", "abbreviation": "MD" },
                { "name": "Massachusetts", "abbreviation": "MA" },
                { "name": "Michigan", "abbreviation": "MI" },
                { "name": "Minnesota", "abbreviation": "MN" },
                { "name": "Mississippi", "abbreviation": "MS" },
                { "name": "Missouri", "abbreviation": "MO" },
                { "name": "Montana", "abbreviation": "MT" },
                { "name": "Nebraska", "abbreviation": "NE" },
                { "name": "Nevada", "abbreviation": "NV" },
                { "name": "New Hampshire", "abbreviation": "NH" },
                { "name": "New Jersey", "abbreviation": "NJ" },
                { "name": "New Mexico", "abbreviation": "NM" },
                { "name": "New York", "abbreviation": "NY" },
                { "name": "North Carolina", "abbreviation": "NC" },
                { "name": "North Dakota", "abbreviation": "ND" },
                { "name": "Northern Mariana Islands", "abbreviation": "MP" },
                { "name": "Ohio", "abbreviation": "OH" },
                { "name": "Oklahoma", "abbreviation": "OK" },
                { "name": "Oregon", "abbreviation": "OR" },
                { "name": "Palau", "abbreviation": "PW" },
                { "name": "Pennsylvania", "abbreviation": "PA" },
                { "name": "Puerto Rico", "abbreviation": "PR" },
                { "name": "Rhode Island", "abbreviation": "RI" },
                { "name": "South Carolina", "abbreviation": "SC" },
                { "name": "South Dakota", "abbreviation": "SD" },
                { "name": "Tennessee", "abbreviation": "TN" },
                { "name": "Texas", "abbreviation": "TX" },
                { "name": "Utah", "abbreviation": "UT" },
                { "name": "Vermont", "abbreviation": "VT" },
                { "name": "Virgin Islands", "abbreviation": "VI" },
                { "name": "Virginia", "abbreviation": "VA" },
                { "name": "Washington", "abbreviation": "WA" },
                { "name": "West Virginia", "abbreviation": "WV" },
                { "name": "Wisconsin", "abbreviation": "WI" },
                { "name": "Wyoming", "abbreviation": "WY" }
            ],
            phoneRules: [
                v => !!v || "Home Phone Required",
                v => !v || /^[0-9]{3}-[0-9]{3}-[0-9]{4}/.test(v) || 'Phone number must be valid'
            ],
            secondaryPhoneRules: [
                v => !v || /^[0-9]{3}-[0-9]{3}-[0-9]{4}/.test(v) || 'Phone number must be valid'
            ],
            emailRules: [
                v => !!v || "Email Required",
                v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
            ],
            optionalEmailRules: [
                v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
            ],
            zipRules: [
                v => !!v || "Zip Required",
                v => !v || /^\d{5}(-\d{4})?$/.test(v) || 'Enter a valid ZIP code (12345 or 12345-6789)'
            ],
            monthYearRule: [
                v => !!v || "Month/Year Required",
                v => !v || /^(0[1-9]|1[0-2])\/\d{4}$/.test(v) || 'Format must be MM/YYYY (e.g. 01/2026)'
            ],
        };
      },
        methods: {
          LoadData() {
            this.loading = true;

            myfetch('/api/ResumeType/2', { method: 'GET' })
                .then(response => response.json())
                .then(data => {
                    EncodeDatetimes(data);
                    const now = new Date().setHours(0,0,0,0);
                    this.item = data;
                    if (this.item && this.item.length > 0 && this.item[0].StartDate && this.item[0].EndDate && (now <= new Date(this.item[0].EndDate) && now >= new Date(this.item[0].StartDate))) {
                        this.Active = true;
                        this.endDate = this.item[0].EndDate;
                    }
                    this.loading = false;
                });

          },
          submit() {
              this.submitting = true
              this.form.DateSigned = new Date();
              if (this.$refs.form.validate()) {
                  myfetch('/api/Resume/2', {
                      method: 'POST',
                      credentials: 'include',
                      headers: {
                          "Content-Type": "application/json"
                      },
                      body: JSON.stringify(JSON.stringify(this.form))
                  }).then(res => {
                      if (res.ok) {
                          this.submitted = true;
                          this.form = this.resetForm;
                          this.$refs.form.resetValidation();
                          this.submitting = false;
                          this.Acknowledgment = false;
                      }
                  });
              } else {
                  this.$nextTick(() => {
                      const firstError = this.$el.querySelector(
                          '.v-input--has-state.error--text'
                      );

                      if (firstError) {
                          firstError.scrollIntoView({
                              behavior: 'smooth',
                              block: 'center'
                          });

                          // Optional: focus the input inside
                          const input = firstError.querySelector('input, textarea');
                          if (input) input.focus();
                      }
                  });
                  this.submitting = false
              }
          }
        },
        mounted() {
            this.LoadData();
        },
      metaInfo() {
            return {
                title: this.Title,
                meta: [
                    { vmid: 'description', name: 'description', content: this.Description },
                    // OpenGraph data (Most widely used)
                    { vmid: 'og:title', property: 'og:title', content: this.Title + ' | South Dakota Legislature' },
                    // The list of types is available here: http://ogp.me/#types
                    { vmid: 'og:type', property: 'og:type', content: 'website' },
                    // Should be the same as your canonical link, see below.
                    { vmid: 'og:url', property: 'og:url', content: window.location.href },
                    // Often the same as your meta description, but not always.
                    { vmid: 'og:description', property: 'og:description', content: this.Description },

                    // Twitter card
                    { vmid: 'twitter:card', name: 'twitter:card', content: 'summary' },
                    { vmid: 'twitter:site', name: 'twitter:site', content: window.location.href },
                    { vmid: 'twitter:title', name: 'twitter:title', content: this.Title + ' | South Dakota Legislature' },
                    { vmid: 'twitter:description', name: 'twitter:description', content: this.Description }
                ],
                link: [
                    { vmid: 'canonical', rel: 'canonical', href: window.location.href.split('?')[0] }
                ]
            }
        }
};
</script>